'use strict';

import CustomControls from "./CustomControls";
import Helpers from "./Helpers";

class Reserve {
    constructor(initALL = true) {
        console.log('Init Reserve module');
        if (initALL) this.initVars().initSizes().initOnStart().initSubmitForm();
    }

    initVars() {
        return this;
    }

    initOnStart() {
        $("#reserve-candidate").on("click", ".add-item", event => {this.onAddReserve(event); return false;});

        $('table.reserve tbody')
            .on("click", ".del-item", event => {
                if (confirm("Вы уверены?")) {
                    $(event.currentTarget).closest("tr").remove();
                }
                return false;
            });

        return this;
    }

    initSubmitForm() {
        $("#reserve-form").on("submit", (event) => {
            let $form = $(event.target);
            let itemName = $form.data("item-name");

            $.each($("table.reserve tbody tr"), (index, tr) => {
                $("<input type='hidden' name='" + itemName + "[" + index + "].artikul.ID' value='" + $(tr).children().eq(0).data("id") + "'/>").appendTo($form);
                $("<input type='hidden' name='" + itemName + "[" + index + "].artikul.name' value='" + $(tr).children().eq(0).data("name") + "'/>").appendTo($form);
                $("<input type='hidden' name='" + itemName + "[" + index + "].qty' value='" + Helpers.cleanSpaces($(tr).children().eq(1).text()) + "'/>").appendTo($form);
            });
        });

        return this;
    }

    initSizes() {
        // let $selects_options = $("select[id^=RESERVE]").on("change", (event) => this.filter(event)).find("option[selected]");
        $("select[id^=RESERVE]").on("change", (event) => this.filter(event));
        $("#RESERVE_series").trigger("change");

        return this;
    }

    onAddReserve(event) {
        let $tds = $(event.currentTarget).closest("tr").children();
        let balance = +$tds.eq(1).html();
        if (balance > 0) {
            let $next_tr = $("<tr>")
                .append($('<td class="font-weight-bold text-left"/>').html($tds.eq(0).html()).data("id", $tds.eq(0).data("id")).data("name", $tds.eq(0).data("name")))
                .append(CustomControls.makeTableQtyControl($('<td/>').html($tds.eq(2).find("input").val()).data("min", 1).data("max", balance)))
                .append($('<td><a href="#" class="del-item"><img src="/assets/img/delete_normal.svg" alt="del"></a></td>'));

            $("table.reserve tbody").prepend($next_tr);

            $tds.parent().remove();
        }
        return this;
    }

    filter(event) {

        let dlinas = $("#RESERVE_dlin").val(),
            shirinas = $("#RESERVE_shir").val(),
            visotas = $("#RESERVE_vis").val(),
            series = $("#RESERVE_series").val();

        $.ajax({
            type: "get",
            dataType: "html",
            cache: false,
            url: "convector-reserve-list" + "?dlina=" + dlinas + "&shirina=" + shirinas + "&visota=" + visotas + "&series=" + series,
            async: true,
        })
        .done((list) => {
            let $loadedTbody = $(list);
            CustomControls.makeTableInputSpinner($loadedTbody);
            $("#reserve-candidate > tbody").replaceWith($loadedTbody);
        })
        .fail(data => {
            console.log("fail: ", data);
        })
        .always(() => { /* console.log("always"); */
        });
        return this;
    }
}

export default Reserve;